export enum ObjectToBlur {
  FACES = 'faces',
  VEHICLES = 'vehicles',
}
